import React from "react";
import "../styles/StatCardThree.css";

const StatCardThree = () => {
    return (
        <div className="stat-card-three">
            <img src="/total-icon.svg" alt="Total Icon" className="total-icon" />
            <div className="stats-header">
                <p className="stats-title">Total Projects</p>
                <img src="/uparrow-icon.svg" alt="Up Arrow" className="up-arrow-icon" />
                <p className="stats-percentage">8%</p>
            </div>
            <p className="stats-value">1932+</p>
            <p className="stats-increase">
                Increase of <span className="highlight">126</span> this month
            </p>
        </div>
    );
};

export default StatCardThree;
